import * as types from './sessions.types';

export const sessionsPageSelectors: types.ISessionsPageSelectors = {
  selectSessionIds: (state) => state.page.sessions.sessionIds,
  selectNextSessionId: (state) => state.page.sessions.nextSessionId,
  selectLastSessionId: (state) => state.page.sessions.lastSessionId,
  selectNotAttendedIds: (state) => state.page.sessions.notAttendedIds,
};
